import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'w-fit shrink-0 rounded-[6.188rem] bg-(image:--accent-gradient) px-2 py-[0.16rem] ' +
            'font-(family-name:--primary-font) text-[0.56rem] font-extrabold uppercase tracking-[0.08em] ' +
            'text-(--pure-white) shadow-(--progress-glow-shadow-xs)'
    }
} satisfies ComponentTheme;
